import { useSearchParams } from 'react-router-dom'

const NATIVE_PLATFORMS = ['ios', 'android'] as const

/** Строку из query или куки нативки — в платформу; всё прочее считаем вебом */
export const parseAppPlatform = (value: string | null | undefined) =>
  NATIVE_PLATFORMS.find((native) => native === value) ?? ('web' as const)

/** Где открыта страница: нативка, открывая webview, дописывает `?platform=ios|android` */
export const useAppPlatform = () => {
  const [searchParams] = useSearchParams()

  return parseAppPlatform(searchParams.get('platform'))
}
